<template>
  <div
    class="pop-img-box"
    :class="alignClass"
  >
    <el-popover
      placement='right'
      trigger='hover'
      :disabled="disabled"
      :open-delay="200"
    >
      <img class="good-avatar" :src="url || errImg" />
      <div
        slot='reference'
        :style="{height: `${imgWidth}px`, width: `${imgWidth}px`}"
        class="good-avatar-small-box"
      >
        <img :style="{maxHeight: `${imgWidth}px`, maxWidth: `${imgWidth}px`}" class='good-avatar-small' :src="url || errImg" />
      </div>
    </el-popover>
  </div>
</template>

<script>
import errImg from '@/assets/images/no_image.png'
export default {
  props: {
    url: String,
    imgWidth: {
      type: [Number, String],
      default: 40
    },
    disabled: {
      type: Boolean,
      default: false
    },
    alignClass: {
      type: String,
      default: 'center'
    },
  },
  data() {
    return {
      errImg
    }
  }
}
</script>

<style lang="scss" scoped>
.pop-img-box{
  display: flex;
  &.left{
    justify-content: flex-start;
  }
  &.center{
    justify-content: center
  }
  &.right{
    justify-content: flex-end;
  }
}
.good-avatar{
  max-height: 200px;
  max-width: 200px;
  margin: 0 auto;
  display: block;
}
.good-avatar-small-box{
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: 1px solid $G4;
  box-sizing: content-box;
  .good-avatar-small{
    margin: 0 auto;
    display: block;
  }
}
</style>
